<template>
  <form class="card rounded-top" @submit.prevent="save">
    <div class="row card-body ">
      <div class="form-group col-12">
        <w-input :model="$schema.name" :title="$t($schema.name.$schema.title)" />
      </div>

      <div class="form-group col-12">
        <w-input :model="$schema.subject" :title="$t($schema.subject.$schema.title)" />
      </div>

      <div class="form-group col-xs-12 col-md-6">
        <w-input :model="$schema.fromAddress" :title="$t($schema.fromAddress.$schema.title)" />
      </div>

      <div class="form-group col-xs-12 col-md-6">
        <w-input :model="$schema.fromName" :title="$t($schema.fromName.$schema.title)" />
      </div>

      <div class="form-group col-12">
        <w-input :model="$schema.to" :title="$t($schema.to.$schema.title)" />
      </div>

      <div class="form-group col-12">
        <w-monaco language="html" :model="$schema.body" :title="$t($schema.body.$schema.title)" />
      </div>

      <div class="col-12 text-right card-actions">
        <button class="btn btn-dark btn-lg rounded-pill" @click.prevent="cancel">
          {{ $t('buttons.cancel') }}
        </button>

        <button type="submit" class="btn btn-smart btn-lg rounded-pill">{{ $t('buttons.save') }}</button>
      </div>
    </div>
  </form>
</template>

<script>
import { formViewMixin } from '@/mixins/formView';
import schema from '@/schemas/mailTemplate.schema';

const emptyData = () => ({
  name: '',
  subject: '',
  fromAddress: '',
  fromName: '',
  to: '',
  body: ''
});

const messages = {
  added: 'messages.mailTemplate.added',
  addError: 'messages.mailTemplate.addError',
  formError: 'messages.mailTemplate.formError',
  updated: 'messages.mailTemplate.updated',
  updateError: 'messages.mailTemplate.updateError'
};

// @vuese
// Formularz szablonu wiadomości
// @group MailTemplate
export default {
  schema,
  mixins: [formViewMixin('mailTemplate', messages, emptyData)]
};
</script>